<!-- Skeleton Loader -->
@if (loading) {
  <div class="dash-main-content">
    <div class="dash-top">
      <h2 class="dash-title">Gestion des applications</h2>
    </div>
    <!-- Tabs squelette -->
    <div class="tabs">
      <div class="dash-action">
        <div class="dash-action-left">
          <div class="tab-list" role="tablist">
            @for (tab of tabs; track tab; let i = $index) {
              <button class="skeleton-tab">
                {{ tab.label }}
                <small class="badge skeleton-badge"></small>
              </button>
            }
          </div>
        </div>
        <div class="dash-action-right">
          <div class="field-search-btn">
            <input type="text" placeholder="Rechercher" class="search-icon" disabled>
            <button disabled>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.0003 11.9998L4.00024 11.9998" stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.0003 17C15.0003 17 20.0002 13.3176 20.0002 12C20.0003 10.6824 15.0002 7 15.0002 7" stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <a class="button button-icon primary skeleton-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4V20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 12H20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Créer une application</span>
          </a>
        </div>
      </div>
      <!-- Table squelette -->
      <div class="tab-panels">
        <div class="tab-panel active">
          <table class="table">
            <thead>
              <tr>
                <!-- <th>Favorits</th> -->
                <th>Applications</th>
                <th>Type</th>
                <th>Statut</th>
                <!-- <th>Protocole</th> -->
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (_ of [1,2,3,4,5]; track _) {
                <tr>
                  <!-- <td><div class="skeleton-line w-24"></div></td> -->
                  <td>
                    <div class="flex flex-direction-column gap-8">
                      <div class="skeleton-line w-32"></div>
                      <div class="skeleton-line w-48"></div>
                    </div>
                  </td>
                  <td><div class="skeleton-line w-16"></div></td>
                  <td><div class="skeleton-line w-24"></div></td>
                  <!-- <td><div class="skeleton-line w-20"></div></td> -->
                  <td><div class="skeleton-line w-32"></div></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
}

<!-- Contenu réel -->
@if (!loading) {
  <div class="dash-main-content">
    <!-- Titre & actions -->
    <div class="dash-top">
      <h2 class="dash-title">Les applications</h2>
    </div>
    <!-- Tabs -->
    <div class="tabs">
      <div class="dash-action">
        <div class="dash-action-left">
          <div class="tab-list" role="tablist" aria-label="Tabs">
            @for (tab of tabs; track tab; let i = $index) {
              <button
                role="tab"
                [attr.aria-selected]="selectedTabIndex === i"
                [attr.aria-controls]="'panel-' + (i+1)"
                [id]="'tab-' + (i+1)"
                (click)="selectTab(i)"
                [class.active]="selectedTabIndex === i"
                >
                {{ tab.label }}
                <small class="badge" [ngClass]="tab.badgeClass">{{ tab.count }}</small>
              </button>
            }
          </div>
        </div>
        <div class="dash-action-right">
          <div class="field-search-btn">
            <input
              type="text"
              placeholder="Rechercher"
              class="search-icon"
              [formControl]="searchControl"
              >
              @if (searchControl.value) {
                <button (click)="searchControl.setValue('')">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18" stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 6L18 18" stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              } @else {
                <button>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.0003 11.9998L4.00024 11.9998" stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.0003 17C15.0003 17 20.0002 13.3176 20.0002 12C20.0003 10.6824 15.0002 7 15.0002 7" stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              }
            </div>
            <a routerLink="/dashboard/clients/add" class="button button-icon primary">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4V20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 12H20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Créer une application</span>
            </a>
          </div>
        </div>
        <!-- Panneaux -->
        <div class="tab-panels">
          @for (tab of tabs; track tab; let i = $index) {
            <div
              [id]="'panel-' + (i+1)"
              class="tab-panel"
              [class.active]="selectedTabIndex === i"
              role="tabpanel"
              [attr.aria-labelledby]="'tab-' + (i+1)"
              [hidden]="selectedTabIndex !== i"
              >
              <!-- Tableau -->
              @if (filteredClients.length > 0) {
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <!-- <th>Favorits</th> -->
                        <th>Applications</th>
                        <th>Type</th>
                        <th>Statut</th>
                        <!-- <th>Protocole</th> -->
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (client of filteredClients | slice: (currentPage * pageSize) : ((currentPage + 1) * pageSize); track client) {
                        <tr>
                          <!-- Favoris -->
                          <!-- <td>
                          <div class="flex gap-8 align-center">
                            <button class="flex align-center gap-8 button-no-style" (click)="toggleFavorite(client)">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M4 17.9808V9.70753C4 6.07416 4 4.25748 5.17157 3.12874C6.34315 2 8.22876 2 12 2C15.7712 2 17.6569 2 18.8284 3.12874C20 4.25748 20 6.07416 20 9.70753V17.9808C20 20.2867 20 21.4396 19.2272 21.8523C17.7305 22.6514 14.9232 19.9852 13.59 19.1824C12.8168 18.7168 12.4302 18.484 12 18.484C11.5698 18.484 11.1832 18.7168 10.41 19.1824C9.0768 19.9852 6.26947 22.6514 4.77285 21.8523C4 21.4396 4 20.2867 4 17.9808Z"
                                  [attr.fill]="favoriteIds.has(client.id) ? '#45B56F' : 'none'"
                                  stroke="#1E1F24"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  />
                                </svg>
                                <span>Favoris</span>
                              </button>
                            </div>
                          </td> -->
                          <!-- Infos application -->
                          <td>
                            <div class="flex flex-direction-column gap-8">
                              <p class="m-0">{{ client.name || client.clientId }}</p>
                              <span class="text-gray">{{ client.description || 'Aucune description' }}</span>
                            </div>
                          </td>
                          <!-- Type -->
                          <td>
                  <div class="badge" [ngClass]="{
                    'success': client.publicClient && !client.bearerOnly,
                    'purple': !client.publicClient && !client.bearerOnly,
                    'danger': client.bearerOnly
                  }">
                              {{ getClientTypeLabel(client) }}
                            </div>
                          </td>
                          <!-- Statut -->
                          <td>
                            <form>
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  [checked]="client.enabled"
                                  (change)="toggleClientStatus(client, $event)"
                                  [disabled]="isClientBeingToggled(client.id)"
                                  >
                                  <span class="slider round"></span>
                                </label>
                                <span>{{ client.enabled ? 'Activé' : 'Désactivé' }}</span>
                              </form>
                            </td>
                            <!-- Protocole -->
                            <!-- <td>
                  <div class="badge" [ngClass]="{
                    'success': client.protocol === 'openid-connect',
                    'neutral': client.protocol !== 'openid-connect'
                  }">
                              {{ client.protocol || 'openid-connect' }}
                            </div>
                          </td> -->
                          <!-- Actions -->
                          <td>
                            <ul class="table-actions-icons">
                              <li>
                                <a [routerLink]="['/dashboard/clients', client.id, 'edit']">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z" stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round"/>
                                    <path d="M13 4L20 11" stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round"/>
                                    <path d="M14 22L22 22" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </a>
                              </li>
                              <li>
                                <a [routerLink]="['/dashboard/clients', client.id, 'view']">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10" stroke="#5C6465" stroke-width="1.5"/>
                                    <path d="M11.992 15H12.001" stroke="#5C6465" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12 12L12 8" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </a>
                              </li>
                              <li>
                                <button
                                  class="table-actions-dropdown button-no-style"
                                  (click)="toggleDropdown(client.id)"
                                  >
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.992 12H12.001" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.9842 18H11.9932" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.9998 6H12.0088" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </button>
                                <ul class="table-actions-item" [class.hide]="activeDropdown !== client.id">
                                  <!-- <li><a (click)="navigateToEditClient(client.id)">Gestion des groupes</a></li> -->
                                  <!-- <li><a (click)="regenerateSecret(client)">Réinitialiser mot de passe</a></li> -->
                                  <li><a (click)="openDeleteDialog(client)">Supprimer</a></li>
                                </ul>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                  <!-- Pagination -->
                  @if (filteredClients.length > pageSize) {
                    <div class="pagination-container">
                      <mat-paginator
                        [length]="filteredClients.length"
                        [pageSize]="pageSize"
                        [pageIndex]="currentPage"
                        [pageSizeOptions]="[5, 10, 20, 50]"
                        (page)="onPageChange($event)"
                        showFirstLastButtons
                        >
                      </mat-paginator>
                    </div>
                  }
                </div>
              } @else {
                <div class="no-results-card">
                  <p>Aucune application trouvée</p>
                </div>
              }
              <!-- Aucun résultat -->
            </div>
          }
        </div>
      </div>
    </div>
  }